import { Link } from "react-router-dom";
const MasterTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item" role="presentation">
        <Link
          to={"/industries"}
          className={
            props.pageName === "INDUSTRY"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          INDUSTRY
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/accounttypes"}
          className={
            props.pageName === "ACCOUNTTYPE"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          ACCOUNT TYPE
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/accounts"}
          className={
            props.pageName === "ACCOUNT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          ACCOUNT
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/industryaccounts"}
          className={
            props.pageName === "INDUSTRYACCOUNT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          INDUSTRY ACCOUNT
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/items"}
          className={
            props.pageName === "ITEM"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          ITEM
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/accountitems"}
          className={
            props.pageName === "ACCOUNTITEM"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          ACCOUNT ITEM
        </Link>
      </li>
    </ul>
  );
};

export default MasterTabs;
